
import React from "react";

interface SimplifiedRefundHeaderProps {
  isAuthenticated: boolean;
  hasUsedDemo: boolean;
}

const SimplifiedRefundHeader = ({ isAuthenticated, hasUsedDemo }: SimplifiedRefundHeaderProps) => {
  return (
    <div className="text-center mb-6">
      <h2 className="text-2xl font-bold mb-2">Get Your Refund</h2>
      <p className="text-muted-foreground text-sm">
        {!isAuthenticated && !hasUsedDemo ? "Try it free - no signup required" : "Quick and professional refund requests"}
      </p>
    </div>
  );
};

export default SimplifiedRefundHeader;
